import type { SxProps, Theme } from "@mui/material";
import { Paper, Stack, Typography } from "@mui/material";
import VideoPlayer from "@entrilia/shared/components/previewFile/VideoPlayer";
import CategoryInlineTags from "../../../../common/CategoryInlineTags";
import InvestorCommunicationPortalPreviewNote from "../../InvestorCommunicationPortalPreviewNote";
import { investorCommunicationTypeIcons } from "../../investorCommunicationTypeIcons";
import type { CommunicationImageSource } from "../investorCommunicationDetailsTypes";

interface Props {
  title?: string;
  categoryIds: string[];
  description?: string;
  videoUrl?: string;
  thumbnailSource?: CommunicationImageSource;
  allowDownload: boolean;
}

const playerSx: SxProps<Theme> = { width: "100%", aspectRatio: "16 / 9", bgcolor: "common.black" };

const placeholderSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  aspectRatio: "16 / 9",
  bgcolor: "background.grey",
};

const VideoIcon = investorCommunicationTypeIcons.Video;

const InvestorCommunicationVideoContentPreview = ({
  title,
  categoryIds,
  description,
  videoUrl,
  thumbnailSource,
  allowDownload,
}: Props) => {
  const posterUrl = thumbnailSource && thumbnailSource.kind !== "saved" ? thumbnailSource.url : undefined;

  return (
    <Stack spacing={2.5} sx={{ flex: 1, pt: 2.5 }}>
      <InvestorCommunicationPortalPreviewNote />

      {videoUrl ? (
        <VideoPlayer key={videoUrl} src={videoUrl} poster={posterUrl} sx={playerSx} />
      ) : (
        <Paper variant="outlined" sx={placeholderSx}>
          <VideoIcon color="disabled" sx={{ width: 48, height: 48 }} />
        </Paper>
      )}

      <Typography variant="h2" sx={{ py: 1 }}>
        {title || "Untitled"}
      </Typography>

      {categoryIds.length > 0 && <CategoryInlineTags externalCategoryIds={categoryIds} />}

      {description && <Typography sx={{ whiteSpace: "pre-line" }}>{description}</Typography>}

      <Typography variant="caption" color="textSecondary">
        {allowDownload ? "Investors can download this video" : "Download disabled"}
      </Typography>
    </Stack>
  );
};

export default InvestorCommunicationVideoContentPreview;
